import React, { Component } from "react";
import { CardBody, Card, Label, Col, Button, Row } from "reactstrap";
import './style.css'
import { Preloading } from '../../components/UI/Preloader/action';
import { connect } from "react-redux";
import { addLocalPartyMasterUpload, localPartyMasterTemplateRequest, localPartyMasterDataExcelRequest, localPartyMasterListRequest  } from "./action";
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_NUMBER } from './LocalPartyMasterTable/constants';
import LocalPartyMasterFilterForm from './LocalPartyMasterFilter/index';
import LocalPartyMasterTable from './LocalPartyMasterTable/index';
import { buildLocalPartyMasterListFetchRequest } from './helper';


class LocalPartyMasterUploadUtility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      localPartyMasterExcelFile: '',
      noExcelUploadWarning: '',
      showFilter: false,
      pageSize: this.props.defaultPageSize || DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      currentFilter: {},
      sorted: [{ 
        id: "createdAt",
        desc: true
      }]
    };
  }

  componentDidUpdate(prevProps) {

    if (this.props.localPartyMasterTemplateSuccess !== prevProps.localPartyMasterTemplateSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.localPartyMasterTemplateSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `localPartyMasterExcelFile.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.localPartyMasterTemplateFailure !== prevProps.localPartyMasterTemplateFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.localPartyMasterDataExcelSuccess !== prevProps.localPartyMasterDataExcelSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.localPartyMasterDataExcelSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `Local_Party_Master_Data.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.localPartyMasterDataExcelFailure !== prevProps.localPartyMasterDataExcelFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.addLocalPartyMasterUploadSuccess !== prevProps.addLocalPartyMasterUploadSuccess) {
      this.props.preloading(false)
      const successMessage = this.props.addLocalPartyMasterUploadSuccess?.message || 
                             this.props.addLocalPartyMasterUploadSuccess?.data?.message || 
                             this.props.addLocalPartyMasterUploadSuccess?.data || 
                             'Upload successful';
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {successMessage}
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
    if (this.props.addLocalPartyMasterUploadFailure !== prevProps.addLocalPartyMasterUploadFailure) {
      this.props.preloading(false)
      const errorMessage = this.props.addLocalPartyMasterUploadFailure?.data?.data || 
                           this.props.addLocalPartyMasterUploadFailure?.data?.message || 
                           this.props.addLocalPartyMasterUploadFailure?.data || 
                           'Upload failed';
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; {errorMessage}
        </div>
      );
    }

    if (this.props.addLocalPartyMasterUploadFailureFile && this.props.addLocalPartyMasterUploadFailureFile !== prevProps.addLocalPartyMasterUploadFailureFile) {
      this.props.preloading(false)
      var blob = new Blob([this.props.addLocalPartyMasterUploadFailureFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fileSaver.saveAs(blob, "Local_Party_Master_Errors.xlsx");
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; Upload failed. Please check the downloaded error file for details.
        </div>
      );
    }
  }
  
 openFilter = () => {
  this.setState({ showFilter: true });
};

closeFilter = () => {
  this.setState({ showFilter: false });
};

onSortedChange = (sorted) => {
    this.setState({ 
      sorted: sorted[0],
      pageNumber: DEFAULT_PAGE_NUMBER 
    }, () => {
      this.fetchLocalPartyMasterList();
    });
  };


  fetchLocalPartyMasterList = () => {
    const { pageNumber, pageSize, currentFilter, sorted } = this.state;
    const requestBody = buildLocalPartyMasterListFetchRequest({pageNumber,pageSize,filter: currentFilter,sorted});
    this.props.localPartyMasterListRequest(requestBody);
  };



  componentDidMount() {
    this.fetchLocalPartyMasterList();
  }

  handleApplyFilter = (filter) => {
    this.setState({ 
      showFilter: false,
      currentFilter: filter, 
      pageNumber: DEFAULT_PAGE_NUMBER 
    }, () => {
      this.fetchLocalPartyMasterList();
    });
  };

  onPageChange = (pageIndex) => {
    this.setState({ pageNumber: pageIndex }, () => {
      this.fetchLocalPartyMasterList();
    });
  };

  onPageSizeChange = (pageSize) => {
    this.setState({ 
      pageSize, 
      pageNumber: DEFAULT_PAGE_NUMBER 
    }, () => {
      this.fetchLocalPartyMasterList();
    });
  };

  handleTemplateDownload = () => {
    this.props.preloading(true)
    this.props.localPartyMasterTemplateRequest();
  }

  handleDownloadLocalPartyData = () => {
    this.props.preloading(true)
    this.props.localPartyMasterDataExcelRequest();
  }

  uploadExcel = (event) => {
    this.setState({
      localPartyMasterExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleSubmit = () => {
    if (!this.state.localPartyMasterExcelFile) {
      this.setState({ noExcelUploadWarning: '*Please upload the filled request template!' })
    }
    if (this.state.type === '') {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Upload Type
        </div>
      );
    }

    else {
      this.props.addLocalPartyMasterUpload({ file: this.state.localPartyMasterExcelFile, type: this.state.type });
      this.props.preloading(true);
    }
  }

  render() {
    const paginatedData = this.props.localPartyMasterViewPaginatedList || {};
    const data = paginatedData.content || [];
    const pagination = paginatedData.pageable || {};
    const totalPages = paginatedData.totalPages || 0;

    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0 text-center">Local Party Master Upload</h4>
        </div>
        <Card>
          <CardBody>
            <Label>Upload Local Party Master Template</Label>
            <Row>
              <Col sm="22">
                <Button
                  color="primary"
                  onClick={this.handleTemplateDownload}
                  className="btn color-excel-download "
                >
                  <i className="fa fa-file-excel-o fa-lg"></i>
                  &nbsp;&nbsp;Download Template
                </Button>
                <Row
                  color="primary"
                  className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                  title="Upload Request Template"
                >
                  <input
                    onChange={this.uploadExcel}
                    type="file"
                    name="file"
                    id="file"
                    className="upload-file"
                    title="Upload Request Template"
                    accept=".xlsx"
                  />
                  <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                  Upload Template
                </Row>
                <Label className="uploadType">Upload Type : </Label>
                <div className="localPartyType">
                  <input name="type" type="radio" value="add" onChange={e => { this.setState({ type: e.target.value }) }} />
                  &nbsp;&nbsp;Add New Records
                  <label>
                    <input name="type" type="radio" value="edit" onChange={e => { this.setState({ type: e.target.value }) }} />
                    &nbsp;&nbsp;Update Existing
                  </label>
                </div>
                <Button
                  className="ml-5"
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
                <Button className="ml-5"
                  color="success" onClick={this.handleDownloadLocalPartyData}>Download Existing Data</Button>
                  <Button className="ml-2" color="primary" onClick={this.openFilter}>
                  <i className="fa fa-filter fa-lg"></i> Apply Filters  
                </Button>
                <Row className={(this.state.localPartyMasterExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.localPartyMasterExcelFile) ? this.state.localPartyMasterExcelFile.name : this.state.noExcelUploadWarning}</Row>
                

              </Col>
            </Row>
          </CardBody>
        </Card>
    
      <LocalPartyMasterFilterForm
        isOpen={this.state.showFilter}
        toggle={this.closeFilter}
        onApply={this.handleApplyFilter}
      />


      
      
      <LocalPartyMasterTable
        paginatedResponse={this.props.localPartyMasterViewPaginatedList}
        loading={this.props.loading}
        pageSize={this.state.pageSize}
        pageNumber={this.state.pageNumber}
        onPageChange={this.onPageChange}
        onPageSizeChange={this.onPageSizeChange}
        sorted={this.state.sorted}
        onSortedChange={this.onSortedChange}
      />

      </Col>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  localPartyMasterTemplateSuccess: state.localPartyMasterReducer.localPartyMasterTemplateSuccess,
  localPartyMasterTemplateFailure: state.localPartyMasterReducer.localPartyMasterTemplateFailure,
  addLocalPartyMasterUploadSuccess: state.localPartyMasterReducer.addLocalPartyMasterUploadSuccess,
  addLocalPartyMasterUploadFailure: state.localPartyMasterReducer.addLocalPartyMasterUploadFailure,
  addLocalPartyMasterUploadFailureFile: state.localPartyMasterReducer.addLocalPartyMasterUploadFailureFile,
  localPartyMasterDataExcelSuccess: state.localPartyMasterReducer.localPartyMasterDataExcelSuccess,
  localPartyMasterDataExcelFailure: state.localPartyMasterReducer.localPartyMasterDataExcelFailure,
  localPartyMasterViewPaginatedList: state.localPartyMasterReducer.localPartyMasterListSuccess,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  localPartyMasterTemplateRequest: () => dispatch(localPartyMasterTemplateRequest()),
  localPartyMasterDataExcelRequest: () => dispatch(localPartyMasterDataExcelRequest()),
  addLocalPartyMasterUpload: (data) => dispatch(addLocalPartyMasterUpload(data)),
  localPartyMasterListRequest: (data) => dispatch(localPartyMasterListRequest(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocalPartyMasterUploadUtility);
